<template>
  <div>
    <header class="container-fluid header">
      <section class="row px-3 align-items-center d-flex flex-row">
        <div>
          <img src="../../assets/svg/logo.svg" />
        </div>
        <nav
          role="navigation"
          aria-labelledby="main-navigation"
          class="align-self-center"
        >
          <ul class="none-p-m d-flex">
            <li> <a id="popover-meet" href=""> {{ $ml.get('getToKnow') }} </a> </li> 
            <li> <a id="popover-solutions" href="/"> {{ $ml.get('solutions') }} </a> </li> 
            <li> <a id="popover-bughunters" href="/"> Bughunters </a> </li> 
            <li> <a target="_blank" href="https://bughunt.com.br/contato.html"> {{ $ml.get('contact') }} </a> </li> 
          </ul>
        </nav>

        <b-popover target="popover-meet" triggers="hover" placement="top"> 
          <ul class="navlist">
            <li><a target="_blank" href='https://bughunt.com.br/empresa.html'>{{ $ml.get('aboutUs') }}</a></li>
            <li><a target="_blank" href='https://blog.bughunt.com.br/'>{{ $ml.get('ourBlog') }}</a></li>
            <li><a target="_blank" href='https://bughunt.com.br/faq.html'>{{ $ml.get('doubts') }} FAQ</a></li>
            <li><a target="_blank" href='https://bughunt.com.br/midia.html'>{{ $ml.get('inTheMedia') }}</a></li>
            <li><a target="_blank" href='https://bughunt.com.br/contato.html'>{{ $ml.get('talkToUs') }}</a></li>
          </ul>
        </b-popover>

        <b-popover target="popover-solutions" triggers="hover" placement="top">  
            <p class="my-1">Programas</p> 
            <ul class="navlist">
              <li><a target="_blank" href='https://bughunt.com.br/como-funciona.html'>{{ $ml.get('understandHowItWorks') }}</a></li>
              <li><a target="_blank" href='https://bughunt.com.br/programas-publicos.html'>{{ $ml.get('publicPrograms') }}</a></li>
              <li><a target="_blank" href='https://bughunt.com.br/programas-privados.html'>{{ $ml.get('privatePrograms') }}</a></li>
              <li><a target="_blank" href='https://bughunt.com.br/programas-gerenciados.html'>{{ $ml.get('managedPrograms') }}</a></li>
              <li><a target="_blank" href='https://bughunt.com.br/vulnerability-disclosure-program.html'>{{ $ml.get('vdpPrograms') }}</a></li>
            </ul>  
        </b-popover>

        <b-popover target="popover-bughunters" triggers="hover" placement="top"> 
          <ul class="navlist">
            <li><a target="_blank" href='https://bughunt.com.br/como-funciona-bughunters.html'>{{ $ml.get('howItWorks') }}</a></li>
            <li><a target="_blank" href='https://bughunt.com.br/ranking-bughunters.html'>{{ $ml.get('ranking') }}</a></li>
          </ul>
        </b-popover>

        <nav class="ml-auto">
          <ul class="none-p-m d-flex align-items-center">
            <li class="m-0 dropleft" @click="$refs.dpdLanguage.show()">
              <img
                v-if="this.$ml.current == 'portuguese'"
                src="../../assets/svg/flags/br.svg"
                class="flag pointer"
                aria-haspopup="true"
                aria-expanded="false"
              />
              <img
                v-if="this.$ml.current == 'english'"
                src="../../assets/svg/flags/us.svg"
                class="flag pointer"
                aria-haspopup="true"
                aria-expanded="false"
              />
              <img
                v-if="this.$ml.current == 'spanish'"
                src="../../assets/svg/flags/es.svg"
                class="flag pointer"
                aria-haspopup="true"
                aria-expanded="false"
              />
            </li>
          </ul>
        </nav>

        <b-dropdown
          ref="dpdLanguage"
          right
          split
          class="dropdown-links drop-language"
        >
          <div class="dropdown-item h-notification d-flex pt-3 pb-3">
            <a
              @click="alterLanguage('english')"
              id="flag-change-us"
              class="d-flex no pointer"
            >
              <div class="align-self-start">
                <img src="../../assets/svg/flags/us.svg" />
              </div>
              <div class="pl-2 align-self-start no">
                <h3>English</h3>
                <p>Change primary language to English</p>
              </div>
            </a>
          </div>
          <div class="dropdown-divider m-0 mb-2"></div>
          <div class="dropdown-item h-notification d-flex pb-3">
            <a
              @click="alterLanguage('portuguese')"
              id="flag-change-br"
              class="d-flex no pointer"
            >
              <div class="align-self-start">
                <img src="../../assets/svg/flags/br.svg" />
              </div>
              <div class="pl-2 align-self-start no">
                <h3>Português</h3>
                <p>Trocar o idioma padrão para Português</p>
              </div>
            </a>
          </div>
          <div class="dropdown-divider m-0 mb-2"></div>
          <div class="dropdown-item h-notification d-flex pb-3">
            <a
              @click="alterLanguage('spanish')"
              id="flag-change-es"
              class="d-flex no pointer"
            >
              <div class="align-self-start">
                <img src="../../assets/svg/flags/es.svg" />
              </div>
              <div class="pl-2 align-self-start no">
                <h3>Español</h3>
                <p>Cambiar idioma por defecto a Español</p>
              </div>
            </a>
          </div>
        </b-dropdown>
      </section>
    </header>
  </div>
</template>

<script>
import programService from "../../services/program.service.js";

export default {
  methods: {
    async pageReload(timeMs) {
      await setTimeout(() => {
        window.location.reload();
      }, timeMs);
    },

    async changeLanguage(ln) {
      await programService.postPreferredLanguage(ln);
    },

    async alterLanguage(language) {
    this.$refs.dpdLanguage.hide();
    this.$ml.change(language);
    const ln =
      language === "english" ? "en" : language === "portuguese" ? "pt" : "es";
    await this.changeLanguage(ln);
    const milliseconds = 1;
    await this.pageReload(milliseconds);
  },
  }
}
</script>
  
  <style lang="scss">
    .navlist {
        list-style:none;
        padding:0;
        margin:0;
    }
    .nav-vdp { 
      ul {
        li {
          margin-right: 15px;
          a {
            color: #F7F8F9;
            text-decoration: none;
            font-size: 0.97rem; 
            border-bottom: 2px solid transparent;
            font-weight: 500;
          }
          .flag {
            width: 20px;
            height: 20px;
            border-radius: 22px;
          }
          a:hover:not(.no) {
            transition: 1s;
            color: #F7F8F9;
            border-bottom: 2px solid #E10E71;
          }
          a.no:hover {
            color: rgb(255,255,255);
          }
          a.active {
            color: #F7F8F9;
            border-bottom: 2px solid #E10E71;
          }
        }
      }

    }
</style>